import React from "react";
import { Link } from "react-router-dom";
import Sam from '../../assest/background/Sam.png';
import Dave from '../../assest/background/Dave.png';
function InvestRealState8() {
  document.title = "SimWealth";
  return (
    <>
      <div className="bg bg-InvestRealState1">
      <div data-aos="fade-center" className="container-fluid row  vh-100 w-100">
      <div className="col-sm-3 d-flex  align-items-center justify-content-center ">
        <img src={Dave} className="DaveImage" alt="Dave" />
        </div>
            <div className="col-sm-6 d-flex flex-column align-items-end justify-content-end my-auto text-center ">           <div className="bg-white rounded-border p-3  border border-4 border-dark">
                  <p className="py-1">Both friends know they will "make money," however one of them doesn't understand purchasing power.</p>
                  <p className="py-1">Purchasing power cannot be ignored.</p>
                   <p className="py-1">The more coffee you can buy over time, the higher your purchasing power.</p>
                   <p className="py-1">Let's find out who made the better decision and will be able to afford more coffee.</p>
                  <Link to={'/investing-in-real-estate/decision-making'} className=" threeDButton btn fw-bold  w-50  ">Continue</Link>
                </div>
            </div>
            <div className="col-sm-3 d-flex  align-items-center justify-content-center position-relative">
            <Link to={'/choose-a-simulation'} className=" threeDButton btn fw-bold RightBtn ">MainMenu</Link>
            <img src={Sam} className="SamImage" alt="Sam" /></div>
        </div>
      </div>
    </>
  );
}

export default InvestRealState8;
